import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // Updated to use App.js instead of MapApp.js directly

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);